const sectionCardMediaSliderCss = `
[data-type='section-card-media-slider'] [data-attribute='card-container'] {
  padding: 40px 0;
}

[data-type='section-card-media-slider'] .card-header:not(:empty) {
  margin-bottom: 24px !important;
}

[data-type='section-card-media-slider'] .card-header h1,
[data-type='section-card-media-slider'] .card-header h2,
[data-type='section-card-media-slider'] .card-header h3 {
  font-size: 24px;
  line-height: 29px;
  margin: 0 0 12px 0 !important;
}

[data-type='section-card-media-slider'] .card-header h1:last-child,
[data-type='section-card-media-slider'] .card-header h2:last-child,
[data-type='section-card-media-slider'] .card-header h3:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-card-media-slider'] .card-header p {
  font-size: 16px;
  margin-bottom: 12px !important;
}

[data-type='section-card-media-slider'] .card-header p:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-card-media-slider'] .swiper {
  position: relative;
}

[data-type='section-card-media-slider'] .swiper .swiper-wrapper .wrap-item {
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

[data-type='section-card-media-slider'] .swiper .swiper-wrapper .wrap-item video {
  width: 100%;
  height: 100%;
  display: block;
  cursor: pointer;
  border-radius: 16px;
}

[data-type='section-card-media-slider'] .swiper .swiper-wrapper .wrap-item img {
  width: 100%;
  height: 100%;
  display: block;
  cursor: pointer;
  object-fit: cover;
  aspect-ratio: 1 / 1;
}

[data-type='section-card-media-slider'] .swiper .swiper-wrapper .wrap-item .volume {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #000000a1;
  color: white;
  border-radius: 50%;
  cursor: pointer;
}

[data-type='section-card-media-slider'] .swiper .swiper-wrapper .wrap-item .volume svg {
  width: 20px;
  height: 20px;
}

[data-type='section-card-media-slider'] .swiper-pagination {
  position: relative;
  margin-top: 20px;
}

[data-type='section-card-media-slider'] .swiper-pagination .swiper-pagination-bullet {
  opacity: 1;
  background-color: var(--pagination-inactive-color, #cccccc);
}

[data-type='section-card-media-slider'] .swiper-pagination .swiper-pagination-bullet-active {
  background-color: var(--pagination-active-color, #000) !important;
}

@container (max-width: 768px) {
  [data-type='section-card-media-slider'] [data-attribute='card-container'] {
    padding: 16px 0;
  }

  [data-type='section-card-media-slider'] .card-header {
    padding-inline: 16px;
  }

  [data-type='section-card-media-slider'] .card-header h1,
  [data-type='section-card-media-slider'] .card-header h2,
  [data-type='section-card-media-slider'] .card-header h3 {
    font-size: 20px;
    line-height: 24px;
  }

  [data-type='section-card-media-slider'] .card-header p {
    font-size: 14px;
  }
}
`;
export default sectionCardMediaSliderCss;
